import React from 'react';
import classNames from 'classnames';
import {Location, Link} from '@reach/router';
import './styles.scss';

const Tabs = () => {
  const tabs = [
    {
      name: 'Why we built Hexowatch',
      path: '/about',
    },
    {
      name: 'Team',
      path: 'https://hexact.io/leadership/',
    },
    {
      name: 'Hexowatch use cases',
      path: '/use-cases',
    },
    {
      name: 'How to use Hexowatch',
      path: '/how-to-use-hexowatch',
    },
    {
      name: 'Media Kit',
      path: '/media-kit',
    },
    {
      name: 'Roadmap',
      path: '/roadmap',
    },
  ];

  return (
    <Location>
      {({location}) => (
        <ul className="tab-nav tab-nav-tabs tab_develor_tab mb-30 mt-5">
          {tabs.map(tab => {
            return (
              <li key={tab.name} className="tab-nav-item">
                {tab.path.includes('https://') ? (
                  <a href={tab.path} target="_blank" className="tab-nav-link">
                    {tab.name}
                  </a>
                ) : (
                  <Link
                    to={tab.path}
                    className={classNames('tab-nav-link', {
                      'tab-active': tab.path === location.pathname || `${tab.path}/` === location.pathname,
                    })}
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {tab.name}
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </Location>
  );
};

export default Tabs;
